module.exports = __webpack_public_path__ + "static/img/06-fednet.9589ca06.jpg";